import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import ContactForm from './components/ContactForm';
import FAQ from './pages/FAQ';
import HelpCenter from './pages/HelpCenter';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import CopyrightPolicy from './pages/CopyrightPolicy';
import Ambassadors from './pages/Ambassadors';
import RoyaltyAdvances from './pages/RoyaltyAdvances';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <ScrollToTop>
          <Navigation />
          <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/copyright" element={<CopyrightPolicy />} />
            <Route path="/ambassadors" element={<Ambassadors />} />
            <Route path="/royalty-advances" element={<RoyaltyAdvances />} />
          </Routes>
        </main>
        <Footer />
        </ScrollToTop>
      </div>
    </Router>
  );
}

export default App;
